import { MTFiltersValuesI } from "@services/getMinerList";
import { HashFactorName } from "@utils/hash.utils";
import {
  ActionBaseFilters,
  ActionMTSaveSearch,
  ActionSetMTFilters,
  ActionTypesFilters,
  IHashHamesPayload,
} from "./actionTypes";
import { setFilter } from "./helpers";

export interface MTFilters {
  values: MTFiltersValuesI;
  badges: {
    less: HashFactorName;
    more: HashFactorName;
  }; // бэйджики для множителя хэшрейта
}

interface IState {
  MT_FILTERS: MTFilters;
}

const INITIAL_MINERS_TABLE_FILTERS = {
  values: {
    f_admin_mine: false,
  },
  badges: {
    less: HashFactorName.T,
    more: HashFactorName.T,
  },
};

const initial: IState = {
  MT_FILTERS: INITIAL_MINERS_TABLE_FILTERS,
};

const reducer = (state = initial, action: ActionBaseFilters): IState => {
  switch (action.type) {
    case ActionTypesFilters.SET_MINER_TABLE_FILTERS:
      const act = action as ActionSetMTFilters;
      return {
        ...state,
        MT_FILTERS: act.payload,
      };
    case ActionTypesFilters.SET_MINER_TABLE_SEARCH: {
      const act = action as ActionMTSaveSearch;

      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: { ...state.MT_FILTERS.values, search: act.payload },
        },
      };
    }

    case ActionTypesFilters.SET_ADMIN_MINE_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_admin_mine",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };

    case ActionTypesFilters.SET_MINER_HAS_ERRORS:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_has_errors",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };

    case ActionTypesFilters.SET_WITHOUT_FLAG:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_withoutflag",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_WITHOUT_PLAN:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_withoutplan",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_WITHOUT_CONTRACTS:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_withoutcontract",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };

    case ActionTypesFilters.SET_WITH_DUP_IP:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_with_dup_ip",
            action.payload,
            state.MT_FILTERS.values
          )
        }
      };
    case ActionTypesFilters.SET_WITH_DUP_MAC:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_with_dup_mac",
            action.payload,
            state.MT_FILTERS.values
          )
        }
      };
    // case ActionTypesFilters.SET_WITH_LOCATION:
    //   return {
    //     ...state,
    //     MT_FILTERS: {
    //       ...state.MT_FILTERS,
    //       values: setFilter(
    //         "f_with_location",
    //         action.payload,
    //         state.MT_FILTERS.values
    //       )
    //     }
    //   };

    case ActionTypesFilters.SET_FLAGS:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter("f_flags", action.payload, state.MT_FILTERS.values),
        },
      };

    case ActionTypesFilters.SET_LOCATION_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_location",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_OWNER_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_customer",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_POOL_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_setting_id",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_PERCENT_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_mining_percent",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_SPEED_LESS_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_speed_less",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_SPEED_MORE_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_speed_more",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_DEFAULT_SPEED_LESS_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_speed_default_less",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_DEFAULT_SPEED_MORE_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_speed_default_more",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_INSTALAION_DATE_FILTER_LESS:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_instalation_date_less",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_INSTALAION_DATE_FILTER_MORE:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_instalation_date_more",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_SPEED_LESS_PERCENT_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_speeddrop",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_MINER_TYPE_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter("f_type", action.payload, state.MT_FILTERS.values),
        },
      };
    case ActionTypesFilters.SET_PLAN_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_mining_rate",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_MINER_STATE_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter("f_state", action.payload, state.MT_FILTERS.values),
        },
      };
    case ActionTypesFilters.SET_ALGO_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter("f_hash", action.payload, state.MT_FILTERS.values),
        },
      };
    case ActionTypesFilters.CLEAR_MINER_TABLE_FILTERS:
      return {
        ...state,
        MT_FILTERS: INITIAL_MINERS_TABLE_FILTERS,
      };
    case ActionTypesFilters.SET_BAGES_FILTER:
      const hashBages = action.payload as IHashHamesPayload;
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          badges: {
            less: hashBages.less || state.MT_FILTERS.badges.less,
            more: hashBages.more || state.MT_FILTERS.badges.more,
          },
        },
      };
    case ActionTypesFilters.SET_TAG_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_customer_tags",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };
    case ActionTypesFilters.SET_BUILDING_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_building",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };

    case ActionTypesFilters.SET_CONTRACT_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_contractid",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };

    case ActionTypesFilters.SET_CONTRACT_PLAN_FILTER:
      return {
        ...state,
        MT_FILTERS: {
          ...state.MT_FILTERS,
          values: setFilter(
            "f_planid",
            action.payload,
            state.MT_FILTERS.values
          ),
        },
      };

    default:
      return state;
  }
};

export default reducer;
